export default {
    title: "Neue Kategorie anlegen",
    saveCategory: "Kategorie speichern",
    createCategorySuccess: 'Die Kategorie wurde erfolgreich erstellt.',
    createCategoryError: 'Die Kategorie konnte nicht erstellt werden.'
}